<div class="match_result">
  <h3 class="font-weight-bold text-primary">Carga de Resultado</h3>
  <div class="d-flex justify-content-between">
    <span class="text-primary">{{data.fieldName}}</span>
    <span>{{data.time}}</span>
  </div>
  <div class="teams mb-5">
    <div class="team_a mr-right">
      <div class="team_info">
        <img src="{{data.teamA.image || ''}}" alt="">
        <span>{{data.teamA.name}}</span>
      </div>
      <mat-form-field>
        <input matInput placeholder="Goles" [formControl]="scoreTeamA" type="number">
      </mat-form-field>
    </div>
    <span class="font-weight-bold mx-2">-</span>
    <div class="team_b ml-auto">
      <mat-form-field>
        <input matInput placeholder="Goles" [formControl]="scoreTeamB" type="number">
      </mat-form-field>
      <div class="team_info">
        <span>{{data.teamB.name}}</span>
        <img src="{{data.teamB.image || ''}}" alt="">
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <button mat-button (click)="closeDialog()">Cerrar</button>
    <button mat-raised-button [disabled]="!scoreTeamA.valid || !scoreTeamB.valid" color="primary"
      (click)="loadResult()">Aceptar</button>
  </div>
</div>